let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fRXAy")).then(() => parcelRequire('1W3KQ'));